import $ from 'jquery'

function appendLog($el, text) {
  if (!text) return
  $el.text($el.text() + text)
  $el.scrollTop($el[0].scrollHeight)
}

function setStatus($el, text) {
  $el.text(text)
}

async function startFormDXmlImport(e) {
  e.preventDefault()

  const $btn = $(e.currentTarget)
  const startUrl = $btn.data('start-url')

  const $modal = $('#formDQuestionnaireXmlImportModal')
  const $log = $('#formDQuestionnaireXmlImportLog')
  const $status = $('#formDQuestionnaireXmlImportStatus')

  $log.text('')
  setStatus($status, 'Starting…')
  $modal.find('.modal-footer .btn-review-fdq-xml-import').remove()

  $modal.modal('show')

  let runId
  try {
    const resp = await fetch(startUrl, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
        Accept: 'application/json',
      },
    })

    const data = await resp.json()

    if (!resp.ok) {
      throw new Error(data && data.error ? data.error : 'Failed to start import')
    }

    runId = data.run_id
    setStatus($status, 'Running…')
  } catch (err) {
    setStatus($status, `Error: ${err.message}`)
    return
  }

  let offset = 0
  let attempts = 0
  const maxAttempts = 60 * 30
  let fullLog = ''

  while (attempts < maxAttempts) {
    attempts += 1

    try {
      const progressUrl = `/form_d_questionnaire_xml_import_runs/${encodeURIComponent(runId)}/progress?offset=${offset}`
      const resp = await fetch(progressUrl, { headers: { Accept: 'application/json' } })

      if (resp.status === 404) {
        await new Promise((r) => setTimeout(r, 750))
        continue
      }

      const data = await resp.json()

      if (resp.ok) {
        appendLog($log, data.chunk)
        fullLog += data.chunk
        offset = data.offset

        if (data.done) {
          setStatus($status, 'Finished. See log below.')
          $log.scrollTop($log[0].scrollHeight)

          const cacheIdMatch = fullLog.match(/Cached Form D XML import results \(ID: (\d+)\)/)

          if (cacheIdMatch && cacheIdMatch[1]) {
            const cacheId = cacheIdMatch[1]
            const issuerId = window.location.pathname.match(/\/admin\/issuers\/([a-zA-Z0-9]+)/)?.[1]

            if (issuerId) {
              const reviewUrl = `/admin/issuers/${issuerId}/form_d_questionnaire_xml_import_caches/${cacheId}`

              const $footer = $modal.find('.modal-footer')
              const $reviewBtn = $('<a>', {
                href: reviewUrl,
                class: 'btn btn-primary btn-review-fdq-xml-import',
                text: 'Review & import',
              })
              $footer.prepend($reviewBtn)
            }
          }

          return
        }
      } else {
        setStatus($status, 'Error reading progress.')
        return
      }
    } catch (err) {
      setStatus($status, `Error: ${err.message}`)
      return
    }

    await new Promise((r) => setTimeout(r, 1000))
  }

  setStatus($status, 'Stopped polling (timeout).')
}

function initFormDQuestionnaireXmlImportModal() {
  $(document).on('click', '[data-action="start-form-d-questionnaire-xml-import"]', startFormDXmlImport)
}

document.addEventListener('DOMContentLoaded', initFormDQuestionnaireXmlImportModal)
